import { Type } from "../Type";
export function lazy(factory, name) {
    return new IslyLazy(factory, name);
}
export class IslyLazy extends Type {
    factory;
    class = "lazy";
    #backend;
    get backend() {
        return (this.#backend ??= this.factory());
    }
    constructor(factory, name) {
        super(name ?? (() => this.backend.name), () => this.backend.condition);
        this.factory = factory;
    }
    is = (value) => (this.#backend ??= this.factory()).is(value);
    createFlaw(value) {
        return this.createFlawFromType(this.backend, value);
    }
    get(value) {
        return this.backend.get(value);
    }
}
//# sourceMappingURL=index.js.map